import { ANALYTICS } from '@/constants/analytics/analytics';

export const getTermsUpdatedSource = (screen: string): string =>
  screen === ANALYTICS.SCREEN.BLOCK_PAGE
    ? ANALYTICS.SOURCE.BLOCK_PAGE
    : ANALYTICS.SOURCE.WEB_APP;

export const getTermsUpdatedEventPayload = (
  eventType: string,
  screen: string
): Record<string, unknown> => ({
  [ANALYTICS.PROPERTIES.EVENT_TYPE]: eventType,
  [ANALYTICS.PROPERTIES.SOURCE]: getTermsUpdatedSource(screen),
  [ANALYTICS.PROPERTIES.SCREEN]: screen,
});
